import {Injectable} from '@angular/core';
import {MatSnackBar, SimpleSnackBar} from "@angular/material/snack-bar";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private readonly snackBarDuration = 3000;

  constructor(private snackBar: MatSnackBar) {
  }

  showSuccess(message: string): void {
    this.snackBar.openFromComponent(SimpleSnackBar, {
      duration: this.snackBarDuration,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      data: {message, action: 'OK'},
      panelClass: 'success-notification'
    });
  }

  showError(message: string, duration: number = 0): void {
    this.snackBar.openFromComponent(SimpleSnackBar, {
      duration: duration,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      data: {message,action: 'OK'},
      panelClass: 'error-notification'
    });
  }

}
